<template>
  <el-popover
    :placement="placement"
    :trigger="trigger"
    :popper-class="popperClass"
  >
    <el-row class="pop-content">
      <el-col :span="24">
        <img :alt="noImageText" :src="photoUrl ? url : ''" :width="imgWidth" :height="imgHeight">
      </el-col>
    </el-row>

    <el-button slot="reference" type="text" @click="handlePreview">{{ buttonText }}</el-button>
  </el-popover>
</template>

<script>
export default {
  name: 'PicPreview',
  props: {
    buttonText: {
      type: String,
      default: '图片'
    },
    photoUrl: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'left'
    },
    trigger: {
      type: String,
      default: 'hover'
    },
    noImageText: {
      type: String,
      default: '图片不存在'
    },
    popperClass: {
      type: String,
      default: ''
    },
    imgWidth: {
      type: Number,
      default: 200
    },
    imgHeight: {
      type: Number,
      default: 200
    },
  },
  computed: {
    url() {
      return `/action/upload/cos_preview?url=${encodeURIComponent(this.photoUrl)}`
    }
  },
  methods: {
    handlePreview() {
      const photoUrl = this.photoUrl
      if (photoUrl) {
        open(this.url, '_blank')
      } else {
        this.$message.warning(this.noImageText)
      }
    },
  }
}
</script>

<style scoped>
.pop-content {
  max-width: 700px;
  max-height: 700px;
  overflow: auto;
}
</style>
